/**
 * いずれかのAPIが通信中かどうかの判定を担う
 * ボタンのdisabled属性などに利用する
 */
import { useEffect, useState } from 'react'

export const useLoadingAny = (loadings: boolean[]) => {
  const [loadingAny, setIsLoadingAny] = useState<boolean>(false);

  useEffect(() => {
    const loading = loadings.some(bool => bool);

    setIsLoadingAny(loading);
  }, loadings);

  return loadingAny;
}
